/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, input, signal, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DokaDateInput } from '@doka/angular-core';

@Component({
  selector: 'app-input-date-picker',
  imports: [FormsModule, ReactiveFormsModule, DokaDateInput],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDatePickerComponent),
      multi: true,
    },
  ],
  template: `
    <doka-date-input
      #field
      [value]="value"
      (valueChange)="handleValueChange($event)"
      (blur)="onTouched()"
      [disabled]="disabled()"
      [alert]="alert() ?? ''"
      calendarType="classic"
      activeView="month"
      ><ng-template #label>
        {{ labelText() }}
      </ng-template>
    </doka-date-input>
  `,
})
export class InputDatePickerComponent implements ControlValueAccessor {
  public readonly labelText = input<string | null>(null);
  public readonly alert = input<string | null>(null);
  public readonly disabledDates = input<(date: Date) => boolean>();
  public readonly showClearButton = input<boolean>(false);
  protected readonly disabled = signal<boolean>(false);

  protected readonly component = viewChild.required(DokaDateInput);

  // onChange callback supplied by Angular forms; invoked when user picks a date
  onChange: (value: Date | undefined) => void = () => {};

  onTouched = () => {};

  protected value: Date | undefined = undefined;

  // Called by Angular when form control value changes externally
  writeValue(value: Date | undefined): void {
    this.value = value;
  }
  // Called when the user changes the date in the UI
  protected handleValueChange(value: Date | undefined): void {
    this.value = value;
    this.onChange(value);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
}
